import ENV_VARS from '@/config'
import { put, get } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

export const getToaster = get(`${BACKEND_SERVER}/toasters`)
export const getToasterNoLoading = get(`${BACKEND_SERVER}/toasters`, { noLoading: true })

export const setToaster = put(`${BACKEND_SERVER}/toasters/bulk`, {
  headers: { 'Content-Type': 'application/json' },
  raw: true
})
export const resetToaster = put(`${BACKEND_SERVER}/toasters/reset`)
